import React from 'react';
import { Outlet } from 'react-router';
import {
  NavigationMenu,
  NavigationMenuList,
  NavigationMenuItem,
  NavigationMenuLink,
} from '@/components/ui/navigation-menu';
import { Link, useLocation } from 'react-router';
import { UserCog, Building2, Shield } from 'lucide-react';

export const AdminLayout: React.FC = () => {
  const location = useLocation();
  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <aside className="flex flex-col justify-between w-72 bg-white border-r border-gray-200 py-6 px-4 shadow-lg min-h-screen">
        <div>
          <div className="flex items-center gap-3 mb-8 px-2">
            <Shield className="w-7 h-7 text-gray-700" />
            <span className="text-xl font-bold tracking-tight text-gray-800">Admin Console</span>
          </div>
          {/* Main Menu */}
          <nav className="mb-6">
            <NavigationMenu orientation="vertical">
              <NavigationMenuList className="flex flex-col gap-1 w-full">
                <NavigationMenuItem className="w-full">
                  <NavigationMenuLink asChild active={location.pathname === '/admin-users'}>
                    <Link
                      to="/admin-users"
                      className={`flex items-center gap-3 px-3 py-2 rounded-md font-medium text-base transition-all duration-150 w-full ${
                        location.pathname === '/admin-users'
                          ? 'bg-gray-200 text-gray-900'
                          : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                      }`}
                    >
                      <UserCog className="w-5 h-5" />
                      管理者ユーザー一覧
                    </Link>
                  </NavigationMenuLink>
                </NavigationMenuItem>
                <NavigationMenuItem className="w-full">
                  <NavigationMenuLink asChild active={location.pathname === '/tenants'}>
                    <Link
                      to="/tenants"
                      className={`flex items-center gap-3 px-3 py-2 rounded-md font-medium text-base transition-all duration-150 w-full ${
                        location.pathname === '/tenants'
                          ? 'bg-gray-200 text-gray-900'
                          : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                      }`}
                    >
                      <Building2 className="w-5 h-5" />
                      テナント一覧
                    </Link>
                  </NavigationMenuLink>
                </NavigationMenuItem>
              </NavigationMenuList>
            </NavigationMenu>
          </nav>
        </div>
      </aside>
      {/* Main Content */}
      <main className="flex-1 min-h-screen bg-gray-50 p-8">
        <div className="max-w-7xl mx-auto">
          {/* カード風の枠でOutletを囲む */}
          <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
};
